module.exports = __webpack_public_path__ + "static/media/vencimiento_amarillo.4672cc0a.svg";